<div class="material-page">
  
  <div class="mdc-layout-grid">
    
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-5-desktop">
        <div>
          <h1 class="mat-headline-3" i18n>Become a Listx Sales Partner</h1>
          <p i18n>
            We offer you the perfect opportunity to earn extra income alongside your current job or even full-time. Your role will be selling second-hand items and handling logistics. You’ll receive a share of the earnings for every item sold!
          </p>
        </div>
      </div>
      <div style="display: flex;align-items: center;justify-content: center;" class="picture mdc-layout-grid__cell mdc-layout-grid__cell--span-7-desktop">
        <div style="width: 220px; height: 220px;position: relative">
          <img-with-placeholder [placeholder]="'/sales-partner/sales-partner_placeholder.webp' | assetUrl">
            <img 
                 fullSizedImage
                 ngSrc="/sales-partner/sales-partner.webp" 
                 ngSrcset="1x, 2x" 
                 width="220" 
                 height="221"/>
          </img-with-placeholder>
        </div>
      </div>
    
      <div class="mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-4" i18n>How does it work?</h2>
        <ol>
          <li i18n>Pick up box(es) of second-hand items (clothes, electronics, toys, books, …) from us or our clients</li>
          <li i18n>Create a sales listing for each item (using our convenient AI solution)</li>
          <li i18n>Share the listings on other platforms and find buyers for the items</li>
          <li i18n>Send the item to the buyer</li>
          <li i18n>You earn a 35% commission on every sale</li>
        </ol>
      </div>
      
      <div class="mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-4" i18n>Why join?</h2>
        <ol>
          <li i18n>Ideal work to do from home, whenever you want</li>
          <li i18n>No costs or risks involved</li>
          <li i18n>It could become your main source of income</li>
        </ol>
      </div>
      
      <div class="get-box-form mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-4" i18n>I’m interested! I’d like to learn more!</h2>
        <p i18n>Leave us your contact information and we’ll get in touch.</p>
        <form *ngIf="!requestSent" [formGroup]="salesPartnerRequestForm" (ngSubmit)="sendRequest()" style="display: flex; flex-direction: column">
          <div>
            <mat-form-field class="form-text-field">
              <mat-label i18n>First Name</mat-label>
              <input matInput formControlName="name" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label i18n>Last Name</mat-label>
              <input matInput formControlName="surname" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label i18n>Email</mat-label>
              <input matInput formControlName="email" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field>
              <mat-label i18n>Phone</mat-label>
              <input matInput formControlName="phone" required>
            </mat-form-field>
          </div>
         <div>
           <mat-form-field>
             <mat-label i18n>Address</mat-label>
             <textarea type="text" matInput formControlName="address" required></textarea>
           </mat-form-field>
         </div> 
         
          <span>     
            <button 
              mat-raised-button 
              type="submit"
              color="accent" 
              angulartics2On="click"
              angularticsAction="Button Pressed"
              angularticsCategory="SUBMIT"
              angularticsLabel="SUBMIT"
              i18n>
              SUBMIT
            </button>
          </span>
        </form>
        <p *ngIf="requestSent" i18n>Thank you!</p>
      </div>
    </div>
  </div>
</div>